import { Button, message } from "antd";
import { useState } from "react";
import { CreateStatementModal } from "./createStatementModal";
import CommissionPlan from "../../../../../../redux/models/commissionPlan";
import K from "../../../../../../utilities/constants";

export const CreateStatementButton = ({
  recruiterId,
  threshold,
  clientExceptions,
  selectedRows,
  disabled,
  onSuccess,
}) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    const { deliveryDate, ...restValues } = values;

    setLoading(true);

    try {
      await CommissionPlan.createCommissionStatement({
        ...restValues,
        recruiterId,
        commissionApproval: selectedRows.data,
        deliveryDate: deliveryDate.format(K.DateFormat.Response),
        billingThreshold: threshold.defaultValue,
        thresholdType: threshold.type,
      });
      message.success("Commission Statement Created");
      setOpen(false);
      onSuccess?.();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button type="primary" onClick={() => setOpen(true)} disabled={disabled}>
        Create Statement
      </Button>
      {open && (
        <CreateStatementModal
          open={open}
          loading={loading}
          threshold={threshold}
          clientExceptions={clientExceptions}
          selectedRows={selectedRows}
          onCancel={() => setOpen(false)}
          onFinish={onFinish}
        />
      )}
    </>
  );
};
